/** @format */

import axios from 'axios';

import appConfig from 'config/app';
import { store } from 'stateContainer/store';
/**
 * Common function to call Fria Maklare API endpoints
 *
 * @param url - Api endpoint to call ex:- healthcheck, registerBroker etc
 * @param httpType - API endpoint HTTP type to use ex:- GET, POST, PUT, DELETE
 * @param data - data object to be passed to the API
 * @param auth -boolean- whether auth params to be included or not - default false
 * @param requestContentType - Request content type ex:- application/json, multipart/formdata etc
 *        default is application/json
 *
 * @returns Object
 *
 * @author Sandun Munasinghe
 * @since 16-08-2022
 */
const callFriaMaklareApi = async (
  endpointUrl,
  httpType = 'GET',
  data = null,
  auth = false,
  requestContentType = 'application/json'
) => {
  let requestParamsObj = {
    timeout: 10000
  };

  const { session } = store.getState();

  const url = `${appConfig.baseApiUrl}/${endpointUrl}`;
  const accessToken = session.data.accessToken;
  if (httpType == 'GET' || httpType == 'DELETE') {
    if (data) {
      requestParamsObj.params = data;
    }

    if (auth) {
      requestParamsObj.headers = {
        Authorization: `Bearer ${accessToken}`
      };
    }
    if (httpType == 'GET') {
      return axios.get(url, requestParamsObj);
    } else {
      return axios.delete(url, requestParamsObj);
    }
  } else if (httpType == 'POST' || httpType == 'PUT') {
    let postRequestObj = {
      method: httpType.toLowerCase(),
      url,
      headers: {
        'Content-Type': requestContentType
      }
    };
    if (data) {
      postRequestObj.data = data;
    }

    if (auth) {
      postRequestObj.headers = {
        ...postRequestObj.headers,
        Authorization: `Bearer ${accessToken}`
      };
    }

    return axios(postRequestObj);
  }
};

export const brokerLoginApiService = async ({
  username,
  password,
  newPassword,
  session
}) => {
  const response = await callFriaMaklareApi('brokerLogin', 'POST', {
    username,
    password,
    newPassword,
    session
  });
  return response;
};

export const brokerLogoutApiService = async ({ refreshToken }) => {
  const response = await callFriaMaklareApi(
    'brokerLogout',
    'POST',
    {
      refreshToken
    },
    true
  );
  return response;
};

export const sendFrilanceEmailService = async ({ data }) => {
  const response = await callFriaMaklareApi(
    'email-service',
    'POST',
    {
      template: 'resend-link-to-admin-template',
      toAddress: appConfig.adminEmail,
      templateData: data,
      source: 'NO_REPLY'
    },
    true
  );
  return response;
};

export const getNotificationsService = async (brokerId) => {
  const response = await callFriaMaklareApi(
    'listBrokerNotifications',
    'GET',
    {
      brokerId
    },
    true
  );
  return response;
};

export const fetchBrokerProfileService = async ({ brokerId, vitecId }) => {
  const response = await callFriaMaklareApi(
    'brokerData',
    'GET',
    { brokerId, vitecId },
    true
  );
  return response;
};
export const fetchBrokerProfileBySlugService = async ({
  brokerSlug,
  vitecId
}) => {
  const response = await callFriaMaklareApi(
    'brokerDataBySlug',
    'GET',
    { brokerSlug, vitecId },
    true
  );
  return response;
};

export const fetchBrokerObjectsService = async ({ profileId, page = 1 }) => {
  const response = await callFriaMaklareApi(
    'listBrokerObjects',
    'GET',
    { brokerId: profileId, page },
    true
  );
  return response;
};
export const fetchBrokerObjectsBySlugService = async ({
  profileSlug,
  page = 1
}) => {
  const response = await callFriaMaklareApi(
    'listBrokerObjectsBySlug',
    'GET',
    { brokerSlug: profileSlug, page },
    true
  );
  return response;
};

export const fetchBrokerObjectService = async (objectId) => {
  const response = await callFriaMaklareApi(
    'objectData',
    'GET',
    { objectId },
    true
  );
  return response;
};

export const updateBrokerService = async (payload) => {
  const response = await callFriaMaklareApi(
    'editBrokerService',
    'PUT',
    { ...payload },
    true
  );
  return response;
};
